<template lang="pug">
  div
    template(v-if="isFetching")
      v-skeleton-loader.pb-2(type="text")
      v-skeleton-loader.pb-2(type="text")
      v-skeleton-loader.pb-2(type="text")
      v-skeleton-loader.pb-2(type="text")
      v-skeleton-loader.pb-2(type="text")
      v-skeleton-loader(type="text")
    template(v-else)
      //- Top Tabs
      v-row.pb-2.pb-md-0(no-gutters)
        v-col(cols="12" md="8")
          v-tabs(v-model="tab" color="basic700" :height="44" :grow="isMobileScreen" show-arrows active-class="font-semibold")
            v-tab.text-sm.font-medium.text-none.px-4(v-for="status in statuses" :key="status") {{ status }}
      v-divider
      //- Tab listing
      v-tabs-items(v-model="tab" style="overflow: unset;")
        v-tab-item
          profile-visit-tab(:key="visitKey")
        v-tab-item
          profile-billing-tab
        v-tab-item
          profile-appointment-tab
</template>

<script>
import {mapState} from 'vuex'
import ProfileVisitTab from '@/components/hq/patient/tabs/ProfileVisitTab.vue'
import ProfileBillingTab from '@/components/hq/patient/tabs/ProfileBillingTab.vue'
import ProfileAppointmentTab from '@/components/hq/patient/tabs/ProfileAppointmentTab.vue'

export default {
  components: {
    ProfileVisitTab, ProfileBillingTab, ProfileAppointmentTab
  },
  data() {
    return {
      visitKey: 0,
      documentKey: 0,
      fileKey: 0,
      tab: null,
      isFetching: false,
    }
  },
  watch: {
    tab(newValue) {
      if (this.isFetching) return
      const paramName = this.statuses[newValue].toLowerCase()
      let query = {
        tab: paramName
      }
      if (this.$route.query?.leadPid) {
        query.leadPid = this.$route.query.leadPid
      }
      if (paramName === 'billings' && this.$route.query?.subtab) {
        query.subtab = this.$route.query?.subtab
      }
      this.$router.push({query}).catch(() => {
      })
    }
  },
  async mounted() {
    this.checkQuery()
  },
  computed: {
    ...mapState('user', ['member']),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    },
    statuses() {
      return ['Visits', 'Billings', 'Appointments']
    },
    patientId() {
      const id = this.$route.params?.id
      if (id) {
        return parseInt(id)
      }
      return null
    }
  },
  methods: {
    checkQuery() {
      const tab = this.$route.query?.tab || null
      if (tab) {
        const index = this.statuses.findIndex(status => status.toLowerCase() === tab.toLowerCase())
        if (index >= 0) {
          this.tab = index
        }
      }
    },
    onUpdateVisit() {
      this.documentKey++
      this.fileKey++
    },
    onUpdateDocument() {
      this.visitKey++
    },
  },
}
</script>

<style lang="scss" scoped>
</style>